export const SET_ACCESSION_ID = 'SET_ACCESSION_ID';
export const SET_HIDDEN_COMPOUNDS = 'SET_HIDDEN_COMPOUNDS';